export const menu = [
  {
    label: 'Home',
    path: '/',
  },
  {
    label: 'About',
    path: '/credentials',
  },
  {
    label: 'Awards & Certificates',
    path: '/certificates',
  },
  // {
  //   label: 'Blog',
  //   path: '/posts',
  // },
  {
    label: 'Contact',
    path: '/contact',
  },
];
